import { IEventDataSource } from "@/types/interfaces";
import { BigBashEvent, GamePoint, RoundPointsFieldEnum } from "@/types/types";

type SaveRoundPointValueConfig = {
	eventDataSource: IEventDataSource;
	event: BigBashEvent;
	gameId: string;
	teamId: string;
	roundNumber: number;
	field: RoundPointsFieldEnum;
	value: number;
};

export async function saveRoundPointValue(config: SaveRoundPointValueConfig): Promise<BigBashEvent> {
	const gamePoint = await config.eventDataSource.setRoundPointValue(
		config.event.id, config.gameId, config.teamId, config.roundNumber, config.field, config.value
	);
	return mergeGamePointIntoEvent(config.event, config.gameId, config.teamId, gamePoint);
}

function mergeGamePointIntoEvent(event: BigBashEvent, gameId: string, teamId: string, gamePoint: GamePoint): BigBashEvent {
	const existingIndex = event.game_points.findIndex(existing => existing.game === gameId && existing.team === teamId);
	const game_points = existingIndex >= 0
		? event.game_points.map((existing, index) => index === existingIndex ? gamePoint : existing)
		: [...event.game_points, gamePoint];
	return { ...event, game_points };
}
